import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { GrupoService } from '../../../../../services/grupo.service';
import { SolicitudService } from '../../../../../services/solicitud.service';
import { DataTableDirective } from 'angular-datatables';
import { EmpresaService } from '../../../../../services/empresa.service';
import { Solicitud } from '../../../../../models/solicitud';

@Component({
  selector: 'app-representantes',
  templateUrl: './representantes.component.html',
  styleUrls: ['./representantes.component.css'],
  providers: [GrupoService, SolicitudService]
})
export class RepresentantesComponent implements OnInit {
  public identity;
  public token;
  public status;
  public message_success;
  public message_error;
  public status_update;
  public message_success_upds;
  public solicitudes;
  public file;
  public solicitud: Solicitud;
  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any> = new Subject();

  public licencia_funcionamiento;
  public nombre_establecimiento;
  public grupo_id;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _grupoService: GrupoService,
    private _solicitudService: SolicitudService,
    private _empresaService: EmpresaService
  ) {
    this.identity = this._grupoService.getIdentity();
    this.token = this._grupoService.getToken();
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    }
    this.getSolicitudes();
  }

  getSolicitudes() {
    this._solicitudService.getSolicitudesRepresentantes(this.token).subscribe(
      response => {
        // Obtener el token 
        if (response.status == 'success') {
          this.solicitudes = response.solicitudes;
          this.dtTrigger.next();
        }
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        } else {
          this.message_error = error;
        }
      }
    );
  }

  getImage(solicitud_id) {
    this._solicitudService.getImage(this.token, solicitud_id).subscribe(
      response => {
        // Obtener el token 
        this.file = URL.createObjectURL(response);
        location.href = this.file;
      },
      error => {
        if (error['status'] == 401) {
          this._router.navigate(['logout/1']);
        }
      }
    );
  }

  addEmpresa(solicitud_id) {
    var message = '¿Está seguro que desea adjuntar la empresa al grupo empresarial?';
    var confirmDeclaracion = confirm(message)
    if (confirmDeclaracion == true) {
      $(".loading").show();
      this.licencia_funcionamiento = $("#licAct" + solicitud_id).val();
      this.grupo_id = $("#gruAct" + solicitud_id).val();

      this.solicitud = new Solicitud(solicitud_id, this.grupo_id, '', '', '', '', '', this.licencia_funcionamiento, '', '', '');

      this._empresaService.assignEmpresa(this.token, this.solicitud).subscribe(
        response => {
          // Obtener el token 
          if (response.status == 'success') {
            $(".loading").hide();
            alert(response.message);
            window.location.href = "./panel_de_control/peticiones-representantes";
          }
        },
        error => {
          $(".loading").hide();
          if (error['status'] == 401) {
            this._router.navigate(['logout/1']);
          } else {

            $(".alta").show();

            this.status = 'error';
            this.message_error = error['error']['message'];

            setTimeout(function () {
              $(".alta").fadeTo(500, 1).slideUp(500, function () {
                $(".alta").hide();
              });
            }, 3000);
          }
        }
      );

    } else {
      return false
    }
  }

  deleteSolicitud(solicitud_id) {
    var message = '¿Está seguro que desea cancelar la petición del grupo empresarial?';
    var confirmDeclaracion = confirm(message)
    if (confirmDeclaracion == true) {
      let observacion = $("#observacion" + solicitud_id).val();
      let info = { observacion }

      $(".loading").show();
      this._solicitudService.delete(this.token, info, solicitud_id).subscribe(
        response => {
          if (response.status == 'success') {
            $(".loading").hide();
            alert(response.message);
            window.location.href = "./panel_de_control/peticiones-representantes";
          }
        },
        error => {
          $(".loading").hide();
          if (error['status'] == 401) {
            this._router.navigate(['logout/1']);
          } else if (error.error.message) {
            $(".loading").hide();
            $(".alta").show();
            this.status = 'error';
            this.message_error = error.error.message;
            setTimeout(function () {
              $(".alta")
                .fadeTo(500, 1)
                .slideUp(500, function () {
                  $(".alta").hide();
                });
            }, 3000);
          } else {
            alert('Existen problemas con el servidor, favor de ponerse en contacto con el proveedor');
          }
        }
      );
    } else {
      return false
    }
  }

}
